import { FETCH_ERROR, FETCH_SUCCESS } from '@nord/tool.redux-api/es/actionTypes';

import { IReduxAction } from '../../types';
import { initialState } from '../constants';
import { IAuthState } from '../types';
import AUTH_ACTIONS from './actionTypes';
import * as apiKeys from './apiKeys';
import { isNetworkRelatedFetchError } from './utils';

type Handler = (state: IAuthState, action: IReduxAction) => IAuthState;

const handleSet: Handler = (_state, action) => {
  return { ...action.payload };
};

const handleUpdate: Handler = (state, action) => {
  return { ...state, ...action.payload };
};

const handleLogout: Handler = (_state, _action) => {
  return { ...initialState };
};

const handleToggleRememberMe: Handler = (state, action) => {
  return { ...state, rememberMe: action.payload };
};

const handleAuthFetch: Handler = (state, action) => {
  const {
    token,
    expires_at: expiresAt,
    renew_token: renewToken,
    renew_expires_at: renewTokenExpiresAt,
    mfa_token: mfaToken,
  } = action.payload;

  if (typeof token !== 'undefined') {
    return {
      ...state,
      token,
      expiresAt,
      renewToken,
      renewTokenExpiresAt,
      error: initialState.error,
    };
  }

  if (typeof mfaToken !== 'undefined') {
    return {
      ...state,
      mfaToken,
      error: initialState.error,
    };
  }

  return {
    ...initialState,
    mfaToken: state.mfaToken,
    error: action.payload.payload,
  };
};

const handleAuthFetchError: Handler = (state, action) => {
  // Prevents logging out users when refreshing token fails due to network error and the action is retried
  if (action.meta?.isRetrying && isNetworkRelatedFetchError(action)) {
    return state;
  }

  return {
    ...initialState,
    mfaToken: state.mfaToken,
    error: action.payload.payload,
  };
};

const reducer = (state: IAuthState = initialState, action: IReduxAction) => {
  const key = action?.meta?.key;

  switch (action.type) {
    case FETCH_SUCCESS:
      if ([apiKeys.LOGIN_POST, apiKeys.REFRESH_TOKEN_POST, apiKeys.LOGIN_SSO_GET].includes(key)) {
        return handleAuthFetch(state, action);
      }
      return state;

    case FETCH_ERROR:
      if ([apiKeys.LOGIN_POST, apiKeys.REFRESH_TOKEN_POST].includes(key)) {
        return handleAuthFetchError(state, action);
      }
      return state;

    case AUTH_ACTIONS.SET:
      return handleSet(state, action);

    case AUTH_ACTIONS.UPDATE:
      return handleUpdate(state, action);

    case AUTH_ACTIONS.LOGOUT:
      return handleLogout(state, action);

    case AUTH_ACTIONS.TOGGLE_REMEMBER_ME:
      return handleToggleRememberMe(state, action);

    default:
      return state;
  }
};

export default reducer;
